var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSeteuk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 200,
    viewBox: "0 0 480 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.375 147.027V184.055H255.625V165.606H217.732V147.027H274.375Z",
    fill: "#050C30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.379 49.4567L245.792 40.3622L233.204 49.4567L238.056 34.7756L225.338 25.6811H240.94L245.792 11L250.643 25.6811H266.115L253.527 34.7756L258.379 49.4567Z",
    fill: "#7A4BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M274.375 129.618L245.792 139.882L217.732 129.618V111.169L245.792 121.303L274.375 111.169V129.618Z",
    fill: "#050C30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.375 102.075L245.792 112.209L217.732 102.075V83.4961L245.792 93.6298L274.375 83.4961V102.075Z",
    fill: "#7A4BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274.375 74.4016L245.792 84.5358L217.732 74.4016V55.823L245.792 66.0867L274.375 55.823V74.4016Z",
    fill: "#050C30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.272 117.405V85.5745H372.582V66.9955H344.653V135.984H372.582V117.405H363.272Z",
    fill: "#050C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M409.819 66.9955V91.4209H400.51V66.9955H381.891V135.984H400.51V110H409.819V135.984H428.569V66.9955H409.819Z",
    fill: "#050C30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M309.383 142.22C296.664 142.22 285.651 152.484 285.651 165.866C285.651 178.728 296.533 188.732 309.383 188.732C322.626 188.732 333.246 178.728 333.246 165.866C333.246 152.484 322.626 142.22 309.383 142.22ZM309.383 172.882C305.712 172.882 302.696 169.504 302.696 165.996C302.696 162.228 305.843 159.11 309.383 159.11C313.71 159.11 316.332 162.228 316.332 165.996C316.332 169.504 313.71 172.882 309.383 172.882Z",
    fill: "#050C30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M314.628 85.5745V107.921H333.246V66.9955H285.651V85.5745H314.628Z",
    fill: "#050C30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.401 117.405V95.0585H285.651V135.984H333.246V117.405H304.401Z",
    fill: "#050C30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158.861 147.027V165.606H173.546V184.055H192.295V165.606H206.456V147.027H158.861Z",
    fill: "#050C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.456 66.9955V135.984H158.861V66.9955H206.456ZM187.707 85.5745H177.479V117.535H187.707V85.5745Z",
    fill: "#050C30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.584 66.9955H128.834V135.984H147.584V66.9955Z",
    fill: "#050C30"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M100.906 66.9955V91.4209H91.5972V110H100.906V135.984H119.525V66.9955H100.906Z",
    fill: "#050C30"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.783 135.984L73.241 113.508L77.699 135.984H94.482L82.4192 91.4209V66.9955H63.6695V91.4209L52 135.984H68.783Z",
    fill: "#050C30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSeteuk);
export default __webpack_public_path__ + "static/media/logo-seteuk.b661824cddb21454138811d5761db0e3.svg";
export { ForwardRef as ReactComponent };